import React from "react";
import { Banner } from "@jsq/ds/core";
import { PaymentBatchReviewState } from "../utils";
import { bannerContainer } from "./styles_vanilla.css";
import { getApprovalsBannerConfig } from "./utils";

export type PaymentBatchReviewInfoBannerProps = {
  reviewState: PaymentBatchReviewState;
  isGPX?: boolean;
};

export const PaymentBatchReviewInfoBanner: React.FC<PaymentBatchReviewInfoBannerProps> = ({
  reviewState,
  isGPX,
}) => {
  const config = getApprovalsBannerConfig(reviewState, !!isGPX);

  if (!config.shouldShow) {
    return null;
  }

  return (
    <div className={bannerContainer}>
      <Banner variant={config.variant} title={config.title} description={config.description} />
    </div>
  );
};

export default PaymentBatchReviewInfoBanner;
